import U from "p-queue";
function j(S) {
  return S && S.__esModule && Object.prototype.hasOwnProperty.call(S, "default") ? S.default : S;
}
var T = { exports: {} }, x;
function A() {
  return x || (x = 1, (function(S) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function i() {
    }
    Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (t = !1));
    function n(h, u, a) {
      this.fn = h, this.context = u, this.once = a || !1;
    }
    function d(h, u, a, r, m) {
      if (typeof a != "function")
        throw new TypeError("The listener must be a function");
      var c = new n(a, r || h, m), s = t ? t + u : u;
      return h._events[s] ? h._events[s].fn ? h._events[s] = [h._events[s], c] : h._events[s].push(c) : (h._events[s] = c, h._eventsCount++), h;
    }
    function p(h, u) {
      --h._eventsCount === 0 ? h._events = new i() : delete h._events[u];
    }
    function f() {
      this._events = new i(), this._eventsCount = 0;
    }
    f.prototype.eventNames = function() {
      var u = [], a, r;
      if (this._eventsCount === 0) return u;
      for (r in a = this._events)
        e.call(a, r) && u.push(t ? r.slice(1) : r);
      return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(a)) : u;
    }, f.prototype.listeners = function(u) {
      var a = t ? t + u : u, r = this._events[a];
      if (!r) return [];
      if (r.fn) return [r.fn];
      for (var m = 0, c = r.length, s = new Array(c); m < c; m++)
        s[m] = r[m].fn;
      return s;
    }, f.prototype.listenerCount = function(u) {
      var a = t ? t + u : u, r = this._events[a];
      return r ? r.fn ? 1 : r.length : 0;
    }, f.prototype.emit = function(u, a, r, m, c, s) {
      var l = t ? t + u : u;
      if (!this._events[l]) return !1;
      var o = this._events[l], b = arguments.length, y, g;
      if (o.fn) {
        switch (o.once && this.removeListener(u, o.fn, void 0, !0), b) {
          case 1:
            return o.fn.call(o.context), !0;
          case 2:
            return o.fn.call(o.context, a), !0;
          case 3:
            return o.fn.call(o.context, a, r), !0;
          case 4:
            return o.fn.call(o.context, a, r, m), !0;
          case 5:
            return o.fn.call(o.context, a, r, m, c), !0;
          case 6:
            return o.fn.call(o.context, a, r, m, c, s), !0;
        }
        for (g = 1, y = new Array(b - 1); g < b; g++)
          y[g - 1] = arguments[g];
        o.fn.apply(o.context, y);
      } else {
        var w = o.length, _;
        for (g = 0; g < w; g++)
          switch (o[g].once && this.removeListener(u, o[g].fn, void 0, !0), b) {
            case 1:
              o[g].fn.call(o[g].context);
              break;
            case 2:
              o[g].fn.call(o[g].context, a);
              break;
            case 3:
              o[g].fn.call(o[g].context, a, r);
              break;
            case 4:
              o[g].fn.call(o[g].context, a, r, m);
              break;
            default:
              if (!y) for (_ = 1, y = new Array(b - 1); _ < b; _++)
                y[_ - 1] = arguments[_];
              o[g].fn.apply(o[g].context, y);
          }
      }
      return !0;
    }, f.prototype.on = function(u, a, r) {
      return d(this, u, a, r, !1);
    }, f.prototype.once = function(u, a, r) {
      return d(this, u, a, r, !0);
    }, f.prototype.removeListener = function(u, a, r, m) {
      var c = t ? t + u : u;
      if (!this._events[c]) return this;
      if (!a)
        return p(this, c), this;
      var s = this._events[c];
      if (s.fn)
        s.fn === a && (!m || s.once) && (!r || s.context === r) && p(this, c);
      else {
        for (var l = 0, o = [], b = s.length; l < b; l++)
          (s[l].fn !== a || m && !s[l].once || r && s[l].context !== r) && o.push(s[l]);
        o.length ? this._events[c] = o.length === 1 ? o[0] : o : p(this, c);
      }
      return this;
    }, f.prototype.removeAllListeners = function(u) {
      var a;
      return u ? (a = t ? t + u : u, this._events[a] && p(this, a)) : (this._events = new i(), this._eventsCount = 0), this;
    }, f.prototype.off = f.prototype.removeListener, f.prototype.addListener = f.prototype.on, f.prefixed = t, f.EventEmitter = f, S.exports = f;
  })(T)), T.exports;
}
var P = A();
const C = /* @__PURE__ */ j(P);
class k extends Error {
  constructor(e, t, i, n, d) {
    super(e), this.name = "SubscribeDevError", this.code = t, this.statusCode = i, this.details = n, this.requestId = d;
  }
}
class q extends k {
  constructor(e, t, i, n) {
    super(e, "INSUFFICIENT_BALANCE", 402, {
      remainingCredits: t,
      requiredCredits: i
    }, n), this.name = "InsufficientBalanceError";
  }
}
class $ extends k {
  constructor(e, t, i, n) {
    super(e, "RATE_LIMIT_EXCEEDED", 429, {
      resetTime: t,
      retryAfter: i
    }, n), this.name = "RateLimitError", this.resetTime = t, this.retryAfter = i;
  }
}
class B extends k {
  constructor(e, t) {
    super(e, "AUTHENTICATION_FAILED", 401, void 0, t), this.name = "AuthenticationError";
  }
}
class M extends k {
  constructor(e, t) {
    super(e, "ACCESS_DENIED", 403, void 0, t), this.name = "AccessDeniedError";
  }
}
class G extends k {
  constructor(e, t) {
    super(e, "NOT_FOUND", 404, void 0, t), this.name = "NotFoundError";
  }
}
class E extends k {
  constructor(e, t, i) {
    super(e, "VALIDATION_ERROR", 400, t, i), this.name = "ValidationError";
  }
}
class J extends k {
  constructor(e, t) {
    super(e, "USER_UNSUBSCRIBED", 402, void 0, t), this.name = "UnsubscribedError";
  }
}
function L(S) {
  const e = Object.values(S).filter((i) => typeof i == "number");
  return Object.entries(S).filter(([i, n]) => e.indexOf(+i) === -1).map(([i, n]) => n);
}
class N {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(e, ...t) {
    const i = t[0];
    if (this._map.set(e, i), i && typeof i == "object" && "id" in i) {
      if (this._idmap.has(i.id))
        throw new Error(`ID ${i.id} already exists in the registry`);
      this._idmap.set(i.id, e);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(e) {
    const t = this._map.get(e);
    return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
  }
  get(e) {
    const t = e._zod.parent;
    if (t) {
      const i = { ...this.get(t) ?? {} };
      delete i.id;
      const n = { ...i, ...this._map.get(e) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
}
function z() {
  return new N();
}
const K = /* @__PURE__ */ z();
class I {
  constructor(e) {
    this.counter = 0, this.metadataRegistry = e?.metadata ?? K, this.target = e?.target ?? "draft-2020-12", this.unrepresentable = e?.unrepresentable ?? "throw", this.override = e?.override ?? (() => {
    }), this.io = e?.io ?? "output", this.seen = /* @__PURE__ */ new Map();
  }
  process(e, t = { path: [], schemaPath: [] }) {
    var i;
    const n = e._zod.def, d = {
      guid: "uuid",
      url: "uri",
      datetime: "date-time",
      json_string: "json-string",
      regex: ""
      // do not set
    }, p = this.seen.get(e);
    if (p)
      return p.count++, t.schemaPath.includes(e) && (p.cycle = t.path), p.schema;
    const f = { schema: {}, count: 1, cycle: void 0, path: t.path };
    this.seen.set(e, f);
    const h = e._zod.toJSONSchema?.();
    if (h)
      f.schema = h;
    else {
      const r = {
        ...t,
        schemaPath: [...t.schemaPath, e],
        path: t.path
      }, m = e._zod.parent;
      if (m)
        f.ref = m, this.process(m, r), this.seen.get(m).isParent = !0;
      else {
        const c = f.schema;
        switch (n.type) {
          case "string": {
            const s = c;
            s.type = "string";
            const { minimum: l, maximum: o, format: b, patterns: y, contentEncoding: g } = e._zod.bag;
            if (typeof l == "number" && (s.minLength = l), typeof o == "number" && (s.maxLength = o), b && (s.format = d[b] ?? b, s.format === "" && delete s.format), g && (s.contentEncoding = g), y && y.size > 0) {
              const w = [...y];
              w.length === 1 ? s.pattern = w[0].source : w.length > 1 && (f.schema.allOf = [
                ...w.map((_) => ({
                  ...this.target === "draft-7" || this.target === "draft-4" || this.target === "openapi-3.0" ? { type: "string" } : {},
                  pattern: _.source
                }))
              ]);
            }
            break;
          }
          case "number": {
            const s = c, { minimum: l, maximum: o, format: b, multipleOf: y, exclusiveMaximum: g, exclusiveMinimum: w } = e._zod.bag;
            typeof b == "string" && b.includes("int") ? s.type = "integer" : s.type = "number", typeof w == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (s.minimum = w, s.exclusiveMinimum = !0) : s.exclusiveMinimum = w), typeof l == "number" && (s.minimum = l, typeof w == "number" && this.target !== "draft-4" && (w >= l ? delete s.minimum : delete s.exclusiveMinimum)), typeof g == "number" && (this.target === "draft-4" || this.target === "openapi-3.0" ? (s.maximum = g, s.exclusiveMaximum = !0) : s.exclusiveMaximum = g), typeof o == "number" && (s.maximum = o, typeof g == "number" && this.target !== "draft-4" && (g <= o ? delete s.maximum : delete s.exclusiveMaximum)), typeof y == "number" && (s.multipleOf = y);
            break;
          }
          case "boolean": {
            const s = c;
            s.type = "boolean";
            break;
          }
          case "bigint": {
            if (this.unrepresentable === "throw")
              throw new Error("BigInt cannot be represented in JSON Schema");
            break;
          }
          case "symbol": {
            if (this.unrepresentable === "throw")
              throw new Error("Symbols cannot be represented in JSON Schema");
            break;
          }
          case "null": {
            this.target === "openapi-3.0" ? (c.type = "string", c.nullable = !0, c.enum = [null]) : c.type = "null";
            break;
          }
          case "any":
            break;
          case "unknown":
            break;
          case "undefined": {
            if (this.unrepresentable === "throw")
              throw new Error("Undefined cannot be represented in JSON Schema");
            break;
          }
          case "void": {
            if (this.unrepresentable === "throw")
              throw new Error("Void cannot be represented in JSON Schema");
            break;
          }
          case "never": {
            c.not = {};
            break;
          }
          case "date": {
            if (this.unrepresentable === "throw")
              throw new Error("Date cannot be represented in JSON Schema");
            break;
          }
          case "array": {
            const s = c, { minimum: l, maximum: o } = e._zod.bag;
            typeof l == "number" && (s.minItems = l), typeof o == "number" && (s.maxItems = o), s.type = "array", s.items = this.process(n.element, { ...r, path: [...r.path, "items"] });
            break;
          }
          case "object": {
            const s = c;
            s.type = "object", s.properties = {};
            const l = n.shape;
            for (const y in l)
              s.properties[y] = this.process(l[y], {
                ...r,
                path: [...r.path, "properties", y]
              });
            const o = new Set(Object.keys(l)), b = new Set([...o].filter((y) => {
              const g = n.shape[y]._zod;
              return this.io === "input" ? g.optin === void 0 : g.optout === void 0;
            }));
            b.size > 0 && (s.required = Array.from(b)), n.catchall?._zod.def.type === "never" ? s.additionalProperties = !1 : n.catchall ? n.catchall && (s.additionalProperties = this.process(n.catchall, {
              ...r,
              path: [...r.path, "additionalProperties"]
            })) : this.io === "output" && (s.additionalProperties = !1);
            break;
          }
          case "union": {
            const s = c, l = n.options.map((o, b) => this.process(o, {
              ...r,
              path: [...r.path, "anyOf", b]
            }));
            s.anyOf = l;
            break;
          }
          case "intersection": {
            const s = c, l = this.process(n.left, {
              ...r,
              path: [...r.path, "allOf", 0]
            }), o = this.process(n.right, {
              ...r,
              path: [...r.path, "allOf", 1]
            }), b = (g) => "allOf" in g && Object.keys(g).length === 1, y = [
              ...b(l) ? l.allOf : [l],
              ...b(o) ? o.allOf : [o]
            ];
            s.allOf = y;
            break;
          }
          case "tuple": {
            const s = c;
            s.type = "array";
            const l = this.target === "draft-2020-12" ? "prefixItems" : "items", o = this.target === "draft-2020-12" || this.target === "openapi-3.0" ? "items" : "additionalItems", b = n.items.map((_, R) => this.process(_, {
              ...r,
              path: [...r.path, l, R]
            })), y = n.rest ? this.process(n.rest, {
              ...r,
              path: [...r.path, o, ...this.target === "openapi-3.0" ? [n.items.length] : []]
            }) : null;
            this.target === "draft-2020-12" ? (s.prefixItems = b, y && (s.items = y)) : this.target === "openapi-3.0" ? (s.items = {
              anyOf: b
            }, y && s.items.anyOf.push(y), s.minItems = b.length, y || (s.maxItems = b.length)) : (s.items = b, y && (s.additionalItems = y));
            const { minimum: g, maximum: w } = e._zod.bag;
            typeof g == "number" && (s.minItems = g), typeof w == "number" && (s.maxItems = w);
            break;
          }
          case "record": {
            const s = c;
            s.type = "object", (this.target === "draft-7" || this.target === "draft-2020-12") && (s.propertyNames = this.process(n.keyType, {
              ...r,
              path: [...r.path, "propertyNames"]
            })), s.additionalProperties = this.process(n.valueType, {
              ...r,
              path: [...r.path, "additionalProperties"]
            });
            break;
          }
          case "map": {
            if (this.unrepresentable === "throw")
              throw new Error("Map cannot be represented in JSON Schema");
            break;
          }
          case "set": {
            if (this.unrepresentable === "throw")
              throw new Error("Set cannot be represented in JSON Schema");
            break;
          }
          case "enum": {
            const s = c, l = L(n.entries);
            l.every((o) => typeof o == "number") && (s.type = "number"), l.every((o) => typeof o == "string") && (s.type = "string"), s.enum = l;
            break;
          }
          case "literal": {
            const s = c, l = [];
            for (const o of n.values)
              if (o === void 0) {
                if (this.unrepresentable === "throw")
                  throw new Error("Literal `undefined` cannot be represented in JSON Schema");
              } else if (typeof o == "bigint") {
                if (this.unrepresentable === "throw")
                  throw new Error("BigInt literals cannot be represented in JSON Schema");
                l.push(Number(o));
              } else
                l.push(o);
            if (l.length !== 0) if (l.length === 1) {
              const o = l[0];
              s.type = o === null ? "null" : typeof o, this.target === "draft-4" || this.target === "openapi-3.0" ? s.enum = [o] : s.const = o;
            } else
              l.every((o) => typeof o == "number") && (s.type = "number"), l.every((o) => typeof o == "string") && (s.type = "string"), l.every((o) => typeof o == "boolean") && (s.type = "string"), l.every((o) => o === null) && (s.type = "null"), s.enum = l;
            break;
          }
          case "file": {
            const s = c, l = {
              type: "string",
              format: "binary",
              contentEncoding: "binary"
            }, { minimum: o, maximum: b, mime: y } = e._zod.bag;
            o !== void 0 && (l.minLength = o), b !== void 0 && (l.maxLength = b), y ? y.length === 1 ? (l.contentMediaType = y[0], Object.assign(s, l)) : s.anyOf = y.map((g) => ({ ...l, contentMediaType: g })) : Object.assign(s, l);
            break;
          }
          case "transform": {
            if (this.unrepresentable === "throw")
              throw new Error("Transforms cannot be represented in JSON Schema");
            break;
          }
          case "nullable": {
            const s = this.process(n.innerType, r);
            this.target === "openapi-3.0" ? (f.ref = n.innerType, c.nullable = !0) : c.anyOf = [s, { type: "null" }];
            break;
          }
          case "nonoptional": {
            this.process(n.innerType, r), f.ref = n.innerType;
            break;
          }
          case "success": {
            const s = c;
            s.type = "boolean";
            break;
          }
          case "default": {
            this.process(n.innerType, r), f.ref = n.innerType, c.default = JSON.parse(JSON.stringify(n.defaultValue));
            break;
          }
          case "prefault": {
            this.process(n.innerType, r), f.ref = n.innerType, this.io === "input" && (c._prefault = JSON.parse(JSON.stringify(n.defaultValue)));
            break;
          }
          case "catch": {
            this.process(n.innerType, r), f.ref = n.innerType;
            let s;
            try {
              s = n.catchValue(void 0);
            } catch {
              throw new Error("Dynamic catch values are not supported in JSON Schema");
            }
            c.default = s;
            break;
          }
          case "nan": {
            if (this.unrepresentable === "throw")
              throw new Error("NaN cannot be represented in JSON Schema");
            break;
          }
          case "template_literal": {
            const s = c, l = e._zod.pattern;
            if (!l)
              throw new Error("Pattern not found in template literal");
            s.type = "string", s.pattern = l.source;
            break;
          }
          case "pipe": {
            const s = this.io === "input" ? n.in._zod.def.type === "transform" ? n.out : n.in : n.out;
            this.process(s, r), f.ref = s;
            break;
          }
          case "readonly": {
            this.process(n.innerType, r), f.ref = n.innerType, c.readOnly = !0;
            break;
          }
          // passthrough types
          case "promise": {
            this.process(n.innerType, r), f.ref = n.innerType;
            break;
          }
          case "optional": {
            this.process(n.innerType, r), f.ref = n.innerType;
            break;
          }
          case "lazy": {
            const s = e._zod.innerType;
            this.process(s, r), f.ref = s;
            break;
          }
          case "custom": {
            if (this.unrepresentable === "throw")
              throw new Error("Custom types cannot be represented in JSON Schema");
            break;
          }
          case "function": {
            if (this.unrepresentable === "throw")
              throw new Error("Function types cannot be represented in JSON Schema");
            break;
          }
        }
      }
    }
    const u = this.metadataRegistry.get(e);
    return u && Object.assign(f.schema, u), this.io === "input" && v(e) && (delete f.schema.examples, delete f.schema.default), this.io === "input" && f.schema._prefault && ((i = f.schema).default ?? (i.default = f.schema._prefault)), delete f.schema._prefault, this.seen.get(e).schema;
  }
  emit(e, t) {
    const i = {
      cycles: t?.cycles ?? "ref",
      reused: t?.reused ?? "inline",
      // unrepresentable: _params?.unrepresentable ?? "throw",
      // uri: _params?.uri ?? ((id) => `${id}`),
      external: t?.external ?? void 0
    }, n = this.seen.get(e);
    if (!n)
      throw new Error("Unprocessed schema. This is a bug in Zod.");
    const d = (a) => {
      const r = this.target === "draft-2020-12" ? "$defs" : "definitions";
      if (i.external) {
        const l = i.external.registry.get(a[0])?.id, o = i.external.uri ?? ((y) => y);
        if (l)
          return { ref: o(l) };
        const b = a[1].defId ?? a[1].schema.id ?? `schema${this.counter++}`;
        return a[1].defId = b, { defId: b, ref: `${o("__shared")}#/${r}/${b}` };
      }
      if (a[1] === n)
        return { ref: "#" };
      const c = `#/${r}/`, s = a[1].schema.id ?? `__schema${this.counter++}`;
      return { defId: s, ref: c + s };
    }, p = (a) => {
      if (a[1].schema.$ref)
        return;
      const r = a[1], { ref: m, defId: c } = d(a);
      r.def = { ...r.schema }, c && (r.defId = c);
      const s = r.schema;
      for (const l in s)
        delete s[l];
      s.$ref = m;
    };
    if (i.cycles === "throw")
      for (const a of this.seen.entries()) {
        const r = a[1];
        if (r.cycle)
          throw new Error(`Cycle detected: #/${r.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
      }
    for (const a of this.seen.entries()) {
      const r = a[1];
      if (e === a[0]) {
        p(a);
        continue;
      }
      if (i.external) {
        const c = i.external.registry.get(a[0])?.id;
        if (e !== a[0] && c) {
          p(a);
          continue;
        }
      }
      if (this.metadataRegistry.get(a[0])?.id) {
        p(a);
        continue;
      }
      if (r.cycle) {
        p(a);
        continue;
      }
      if (r.count > 1 && i.reused === "ref") {
        p(a);
        continue;
      }
    }
    const f = (a, r) => {
      const m = this.seen.get(a), c = m.def ?? m.schema, s = { ...c };
      if (m.ref === null)
        return;
      const l = m.ref;
      if (m.ref = null, l) {
        f(l, r);
        const o = this.seen.get(l).schema;
        o.$ref && (r.target === "draft-7" || r.target === "draft-4" || r.target === "openapi-3.0") ? (c.allOf = c.allOf ?? [], c.allOf.push(o)) : (Object.assign(c, o), Object.assign(c, s));
      }
      m.isParent || this.override({
        zodSchema: a,
        jsonSchema: c,
        path: m.path ?? []
      });
    };
    for (const a of [...this.seen.entries()].reverse())
      f(a[0], { target: this.target });
    const h = {};
    if (this.target === "draft-2020-12" ? h.$schema = "https://json-schema.org/draft/2020-12/schema" : this.target === "draft-7" ? h.$schema = "http://json-schema.org/draft-07/schema#" : this.target === "draft-4" ? h.$schema = "http://json-schema.org/draft-04/schema#" : this.target === "openapi-3.0" || console.warn(`Invalid target: ${this.target}`), i.external?.uri) {
      const a = i.external.registry.get(e)?.id;
      if (!a)
        throw new Error("Schema is missing an `id` property");
      h.$id = i.external.uri(a);
    }
    Object.assign(h, n.def);
    const u = i.external?.defs ?? {};
    for (const a of this.seen.entries()) {
      const r = a[1];
      r.def && r.defId && (u[r.defId] = r.def);
    }
    i.external || Object.keys(u).length > 0 && (this.target === "draft-2020-12" ? h.$defs = u : h.definitions = u);
    try {
      return JSON.parse(JSON.stringify(h));
    } catch {
      throw new Error("Error converting schema to JSON.");
    }
  }
}
function V(S, e) {
  if (S instanceof N) {
    const i = new I(e), n = {};
    for (const f of S._idmap.entries()) {
      const [h, u] = f;
      i.process(u);
    }
    const d = {}, p = {
      registry: S,
      uri: e?.uri,
      defs: n
    };
    for (const f of S._idmap.entries()) {
      const [h, u] = f;
      d[h] = i.emit(u, {
        ...e,
        external: p
      });
    }
    if (Object.keys(n).length > 0) {
      const f = i.target === "draft-2020-12" ? "$defs" : "definitions";
      d.__shared = {
        [f]: n
      };
    }
    return { schemas: d };
  }
  const t = new I(e);
  return t.process(S), t.emit(S, e);
}
function v(S, e) {
  const t = e ?? { seen: /* @__PURE__ */ new Set() };
  if (t.seen.has(S))
    return !1;
  t.seen.add(S);
  const n = S._zod.def;
  switch (n.type) {
    case "string":
    case "number":
    case "bigint":
    case "boolean":
    case "date":
    case "symbol":
    case "undefined":
    case "null":
    case "any":
    case "unknown":
    case "never":
    case "void":
    case "literal":
    case "enum":
    case "nan":
    case "file":
    case "template_literal":
      return !1;
    case "array":
      return v(n.element, t);
    case "object": {
      for (const d in n.shape)
        if (v(n.shape[d], t))
          return !0;
      return !1;
    }
    case "union": {
      for (const d of n.options)
        if (v(d, t))
          return !0;
      return !1;
    }
    case "intersection":
      return v(n.left, t) || v(n.right, t);
    case "tuple": {
      for (const d of n.items)
        if (v(d, t))
          return !0;
      return !!(n.rest && v(n.rest, t));
    }
    case "record":
      return v(n.keyType, t) || v(n.valueType, t);
    case "map":
      return v(n.keyType, t) || v(n.valueType, t);
    case "set":
      return v(n.valueType, t);
    // inner types
    case "promise":
    case "optional":
    case "nonoptional":
    case "nullable":
    case "readonly":
      return v(n.innerType, t);
    case "lazy":
      return v(n.getter(), t);
    case "default":
      return v(n.innerType, t);
    case "prefault":
      return v(n.innerType, t);
    case "custom":
      return !1;
    case "transform":
      return !0;
    case "pipe":
      return v(n.in, t) || v(n.out, t);
    case "success":
      return !1;
    case "catch":
      return !1;
    case "function":
      return !1;
  }
  throw new Error(`Unknown schema type: ${n.type}`);
}
class O extends C {
  constructor(e) {
    super(), this._isConsumed = !1, this._accumulatedResult = null, this._promiseResolver = null, this._promiseRejecter = null, this._consumePromise = null, this.sourceIterable = e;
  }
  /**
   * Async iterator implementation - supports `for await...of` loops
   */
  async *[Symbol.asyncIterator]() {
    if (this._isConsumed)
      throw new Error("StreamableResponse can only be consumed once. Use .clone() to consume multiple times.");
    this._isConsumed = !0;
    try {
      for await (const e of this.sourceIterable)
        this._accumulatedResult = e, this.emit("data", e), yield e;
      this.emit("end"), this._promiseResolver && this._accumulatedResult !== null && this._promiseResolver(this._accumulatedResult);
    } catch (e) {
      const t = e instanceof Error ? e : new Error(String(e));
      throw this.emit("error", t), this._promiseRejecter && this._promiseRejecter(t), t;
    }
  }
  /**
   * Promise implementation - enables `await response` to get final result
   */
  then(e, t) {
    return this._consumePromise || (this._consumePromise = new Promise((i, n) => {
      this._promiseResolver = i, this._promiseRejecter = n, this._isConsumed || this._consumeInBackground();
    })), this._consumePromise.then(e, t);
  }
  /**
   * Promise catch implementation
   */
  catch(e) {
    return this.then(void 0, e);
  }
  /**
   * Promise finally implementation
   */
  finally(e) {
    return this.then(
      (t) => (e?.(), t),
      (t) => {
        throw e?.(), t;
      }
    );
  }
  on(e, t) {
    return e === "data" && !this._isConsumed && !this._consumePromise && this._consumeInBackground(), super.on(e, t);
  }
  once(e, t) {
    return e === "data" && !this._isConsumed && !this._consumePromise && this._consumeInBackground(), super.once(e, t);
  }
  /**
   * Start consuming the stream in the background for event listeners and promise resolution
   */
  async _consumeInBackground() {
    try {
      for await (const e of this)
        ;
    } catch {
    }
  }
  /**
   * Clone the streamable response to allow multiple consumption patterns
   * Note: This requires the underlying source to be re-iterable or cloneable
   */
  clone() {
    if (this._isConsumed)
      throw new Error("Cannot clone a StreamableResponse that has already been consumed");
    return new O(this.sourceIterable);
  }
  /**
   * Check if the stream has been consumed
   */
  get isConsumed() {
    return this._isConsumed;
  }
}
function F() {
  return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
class D extends C {
  constructor(e) {
    super(), this.__LOCAL_CLIENT_WITH_EVENTS__ = !0;
    const t = e.baseUrl || "https://api.subscribe.dev";
    if (this._config = {
      baseUrl: t,
      authorizationUrl: e.authorizationUrl || t.replace("api", "auth"),
      timeout: e.timeout || 6e5,
      // 10 minutes
      maxRetries: e.maxRetries || 2,
      debug: e.debug || !1,
      ...e
    }, this.queue = new U({
      concurrency: 10,
      // Max concurrent requests
      interval: 6e4,
      // 1 minute
      intervalCap: 60
      // Max requests per minute
    }), this.fetch = globalThis.fetch?.bind(globalThis), !this.fetch)
      throw new Error("fetch is not available. Please provide a fetch polyfill.");
    this.debug("SubscribeDevClient initialized", { baseUrl: this._config.baseUrl });
  }
  get config() {
    return this._config;
  }
  get pricingUrl() {
    return `${this._config.baseUrl}/subscribe`;
  }
  get authorizationUrl() {
    return !this._config.accessToken && !this._config.apiKey ? `${this._config.authorizationUrl}/demo` : this._config.authorizationUrl;
  }
  /**
   * Run a prediction
   * Note: Now returns completed predictions directly - no polling needed
   * 
   * @param model - The model to use for the prediction
   * @param options - Configuration options for the prediction
   * @param options.input - Input data (can contain prompt OR messages array with multimodal content)
   * @param options.response_format - Optional response format specification. Supports:
   *   - `{ type: 'json_object' }` - Returns a JSON object
   *   - `{ type: 'json_schema', json_schema: { name: string, schema: object } }` - Returns JSON matching the schema
   *   - `MyZodSchema` - Pass a Zod schema directly for automatic JSON schema conversion
   * @param options.wait - For compatibility - ignored since predictions complete synchronously
   * @returns Promise resolving to the prediction result
   * 
   * @example
   * ```typescript
   * // Basic usage with JSON object response
   * const result = await client.run('gpt-4', {
   *   input: { prompt: 'Hello world' },
   *   response_format: { type: 'json_object' }
   * });
   * 
   * // Using Zod schema directly
   * import { z } from 'zod';
   * const UserSchema = z.object({
   *   name: z.string(),
   *   age: z.number()
   * });
   * 
   * const result = await client.run('gpt-4', {
   *   input: { prompt: 'Generate a user' },
   *   response_format: UserSchema
   * });
   * ```
   */
  run(e, t, i) {
    const { input: n, response_format: d, stream: p } = t, f = i?.streamBy || "chunk", h = F(), u = Date.now();
    this.emit("ai-call-start", {
      type: "ai-call-start",
      timestamp: u,
      requestId: h,
      model: e,
      input: n,
      responseFormat: d,
      isStreaming: !!p
    }), console.log("[SubscribeDevClient] STREAMING DEBUG - Starting prediction", {
      model: e,
      input: typeof n,
      response_format: d,
      stream: p,
      streamFromOptions: t.stream,
      streamTruthy: !!p,
      streamType: typeof p,
      optionsKeys: Object.keys(t)
    }), console.log("[SubscribeDevClient] STREAMING DEBUG - Stream parameter check", {
      stream: p,
      streamFromOptions: t.stream,
      streamTruthy: !!p,
      optionsStream: "stream" in t,
      streamValue: t.stream
    });
    const a = {
      model: e,
      input: t.input
    };
    if (t.response_format && (a.response_format = this.processResponseFormat(t.response_format)), p && (a.stream = !0, console.log("[SubscribeDevClient] STREAMING DEBUG - Added stream to payload", {
      stream: p,
      requestPayload: a
    })), console.log("[SubscribeDevClient] STREAMING DEBUG - Final request payload", {
      requestPayload: a,
      hasStream: "stream" in a,
      streamValue: a.stream
    }), console.log("[SubscribeDevClient] STREAMING DEBUG - Request payload stringified", {
      payloadString: JSON.stringify(a)
    }), p) {
      console.log("[SubscribeDevClient] STREAMING DEBUG - Creating lazy streaming response");
      const r = this, m = {
        [Symbol.asyncIterator]: async function* () {
          try {
            console.log("[SubscribeDevClient] STREAMING DEBUG - Starting lazy request execution");
            const c = await r.makeStreamingRequest("POST", "/v1/run", a, f, t.signal);
            r.debug("Streaming request completed successfully:", {
              type: typeof c,
              hasAsyncIterator: !!(c && typeof c[Symbol.asyncIterator] == "function"),
              isAsyncIterable: c instanceof Object && Symbol.asyncIterator in c
            }), r.emit("usage-changed", { operation: "run", model: e });
            let s = [];
            for await (const l of c)
              s.push(l), yield l;
            r.emit("ai-call-complete", {
              type: "ai-call-complete",
              timestamp: Date.now(),
              requestId: h,
              model: e,
              input: n,
              output: s,
              duration: Date.now() - u,
              success: !0,
              responseFormat: d,
              isStreaming: !0
            });
          } catch (c) {
            throw r.debug("Streaming request failed:", {
              error: c instanceof Error ? c.message : String(c),
              errorType: c instanceof Error ? c.constructor.name : typeof c
            }), r.emit("ai-call-error", {
              type: "ai-call-error",
              timestamp: Date.now(),
              requestId: h,
              model: e,
              input: n,
              error: c instanceof Error ? c.message : String(c),
              duration: Date.now() - u,
              success: !1,
              responseFormat: d,
              isStreaming: !0
            }), c;
          }
        }
      };
      return new O(m);
    } else
      return console.log("[SubscribeDevClient] STREAMING DEBUG - Making regular request (stream was false)", {
        stream: p,
        streamTruthy: !!p,
        requestPayload: a
      }), (async () => {
        try {
          const r = await this.makeRequest("POST", "/v1/run", a, t.signal);
          if (this.debug("Prediction completed", {
            hasOutput: !!r.output
          }), this.emit("usage-changed", { operation: "run", model: e }), this.isZodSchema(t?.response_format))
            try {
              const m = t.response_format, c = r.output?.[0] ?? "{}";
              r.output[0] = m.parse(typeof c == "string" ? JSON.parse(c) : c);
            } catch (m) {
              console.error("Could not parse incoming record to Zod schema: ", m, r.output[0]);
            }
          return this.emit("ai-call-complete", {
            type: "ai-call-complete",
            timestamp: Date.now(),
            requestId: h,
            model: e,
            input: n,
            output: r.output,
            duration: Date.now() - u,
            success: !0,
            responseFormat: d,
            isStreaming: !1
          }), r;
        } catch (r) {
          throw this.emit("ai-call-error", {
            type: "ai-call-error",
            timestamp: Date.now(),
            requestId: h,
            model: e,
            input: n,
            error: r instanceof Error ? r.message : String(r),
            duration: Date.now() - u,
            success: !1,
            responseFormat: d,
            isStreaming: !1
          }), r;
        }
      })();
  }
  /**
   * Process response format, converting Zod schemas to json_schema format
   */
  processResponseFormat(e) {
    return this.isZodSchema(e) ? this.convertZodSchema(e, "native Zod schema") : e;
  }
  /**
   * Check if the provided object looks like a Zod schema
   */
  isZodSchema(e) {
    return e && typeof e == "object" && (typeof e._def == "object" || typeof e.parse == "function") && // Make sure it's not already a proper ResponseFormat object
    !e.type;
  }
  /**
   * Convert a Zod schema to json_schema format
   */
  convertZodSchema(e, t) {
    if (!e || typeof e != "object")
      return this.debug("Invalid Zod schema provided, falling back to json_object", { source: t }), { type: "json_object" };
    try {
      return {
        type: "json_schema",
        json_schema: {
          name: e._def?.typeName || "ZodSchema",
          strict: !0,
          schema: V(e)
        }
      };
    } catch (i) {
      const n = i instanceof Error ? i.message : "Unknown error";
      return this.debug("Failed to convert Zod schema, falling back to json_object", { error: n, source: t }), { type: "json_object" };
    }
  }
  /**
   * Get account balance information
   */
  async getBalance() {
    const t = (await this.makeRequest("GET", "/v1/subscriptions/usage")).credits?.userBalance;
    return {
      allocatedCredits: t?.allocatedCredits || 0,
      usedCredits: t?.usedCredits || 0,
      remainingCredits: t?.remainingCredits || 0
    };
  }
  /**
   * Get user storage data using auth context
   */
  async getStorage(e = {}) {
    const t = new URLSearchParams();
    e.appVersion && t.set("appVersion", e.appVersion);
    const i = `/v1/storage${t.toString() ? "?" + t.toString() : ""}`;
    return this.makeRequest("GET", i);
  }
  /**
   * Update user storage data using auth context
   */
  async setStorage(e, t = {}) {
    const i = new URLSearchParams();
    t.appVersion && i.set("appVersion", t.appVersion);
    const n = `/v1/storage${i.toString() ? "?" + i.toString() : ""}`;
    return this.makeRequest("PUT", n, { sessionData: e });
  }
  /**
   * Delete user storage data using auth context
   */
  async deleteStorage(e = {}) {
    const t = new URLSearchParams();
    e.appVersion && t.set("appVersion", e.appVersion);
    const i = `/v1/storage${t.toString() ? "?" + t.toString() : ""}`;
    await this.makeRequest("DELETE", i);
  }
  /**
   * Get user's subscription status using userKey authentication
   * Requires userKey to be provided in client configuration
   */
  async getSubscriptionStatus() {
    if (console.log("[SubscribeDevClient] getSubscriptionStatus called"), !this._config.userKey)
      throw console.log("[SubscribeDevClient] No userKey provided, throwing ValidationError"), new E(
        "User key is required to get subscription status. Provide userKey in client configuration.",
        { method: "getSubscriptionStatus" }
      );
    console.log("[SubscribeDevClient] Making request to /v1/subscriptions/plan with userKey:", this._config.userKey.substring(0, 10) + "...");
    try {
      const e = await this.makeRequest("GET", "/v1/subscriptions/plan");
      console.log("[SubscribeDevClient] Received response:", {
        hasUserPlan: !!e.userPlan,
        planId: e.userPlan?.planId,
        status: e.userPlan?.status,
        hasPlanDetails: !!e.userPlan?.plan
      });
      const t = e.userPlan;
      if (!t || t.status === "none" || !t.plan)
        return console.log("[SubscribeDevClient] User has no active subscription, returning none status"), {
          hasActiveSubscription: !1,
          status: t?.status || "none"
        };
      const i = {
        hasActiveSubscription: t.status === "active",
        plan: t.plan ? {
          id: t.plan.id || t.planId,
          name: t.plan.name,
          price: t.plan.price,
          tokenLimit: t.plan.tokenLimit || t.plan.token_limit,
          subtitle: t.plan.subtitle,
          description: t.plan.description,
          features: t.plan.features
        } : void 0,
        status: t.status,
        startedAt: t.startedAt,
        endsAt: t.endsAt
      };
      return console.log("[SubscribeDevClient] Returning subscription statuSSSSs:", {
        hasActiveSubscription: i.hasActiveSubscription,
        status: i.status,
        planName: i.plan?.name
      }), i;
    } catch (e) {
      throw console.log("[SubscribeDevClient] Error in getSubscriptionStatus:", {
        errorType: e.constructor.name,
        message: e.message
      }), e;
    }
  }
  /**
   * Get comprehensive usage limits and current consumption
   * Requires userKey to be provided in client configuration
   */
  async getUsageLimits() {
    if (!this._config.userKey)
      throw new E(
        "User key is required to get usage limits. Provide userKey in client configuration.",
        { method: "getUsageLimits" }
      );
    return this.makeRequest("GET", "/v1/subscriptions/usage");
  }
  /**
   * Get comprehensive usage information including credits, rate limits, and consumption
   * Alias for getUsageLimits() - Requires userKey to be provided in client configuration
   */
  async getUsage() {
    return this.getUsageLimits();
  }
  /**
   * Get or create a demo project with a public API key
   * Requires userKey (userToken) to be provided in client configuration
   * The returned API key is public and safe to share
   */
  async getDemoProject() {
    if (!this._config.userKey)
      throw new E(
        "User key is required to get demo project. Provide userKey in client configuration.",
        { method: "getDemoProject" }
      );
    this.debug("Getting demo project");
    const e = await this.makePlatformRequest("POST", "/v1/platform/projects/demo");
    this.debug("Demo project retrieved", {
      hasApiKey: !!e.apiKey,
      projectId: e.id,
      isDemo: e.isDemo
    });
    const t = e.apiKey;
    return console.log("Demo project API key (public and safe to share):", t), e;
  }
  /**
   * Make authenticated HTTP request to platform API using userToken as Bearer token
   */
  async makePlatformRequest(e, t, i) {
    const n = `${this._config.baseUrl}${t}`, d = {
      Authorization: `Bearer ${this._config.userKey}`,
      "Content-Type": "application/json",
      "User-Agent": "@subscribe.dev/client/0.1.0"
    }, p = {
      method: e,
      headers: d,
      signal: AbortSignal.timeout(this._config.timeout)
    };
    i && ["POST", "PUT", "PATCH"].includes(e) && (p.body = JSON.stringify(i)), this.debug("Making platform request", { method: e, url: n, headers: { ...d, Authorization: "[redacted]" } });
    const f = await this.fetch(n, p), h = await f.text();
    let u;
    try {
      u = h ? JSON.parse(h) : null;
    } catch {
      u = { error: { message: h } };
    }
    return f.ok || this.handleErrorResponse(f, u), this.debug("Platform request successful", { status: f.status, data: u }), u;
  }
  /**
   * Make authenticated HTTP request to SubscribeDev API
   */
  async makeRequest(e, t, i, n) {
    return this.queue.add(async () => {
      const d = `${this._config.baseUrl}${t}`, p = {
        "Content-Type": "application/json",
        "User-Agent": "@subscribe.dev/client/0.1.0"
      };
      if (this._config.accessToken)
        p["x-sub-dev-access-token"] = this._config.accessToken, this.debug("Using universal auth with x-sub-dev-access-token", {
          tokenPrefix: this._config.accessToken.substring(0, 10) + "..."
        });
      else if (this._config.apiKey) {
        const r = this._config.apiKey.trim().replace(/=+$/, "");
        p.Authorization = `Bearer ${r}`, this.debug("Using project auth with Authorization header"), this._config.userKey && (p["X-User-Token"] = this._config.userKey, this.debug("Adding X-User-Token for user context"));
      } else
        this.debug("No authentication tokens available - unauthenticated request");
      const f = {
        method: e,
        headers: p,
        signal: n || AbortSignal.timeout(this._config.timeout)
      };
      i && ["POST", "PUT", "PATCH"].includes(e) && (f.body = JSON.stringify(i), this.debug("Regular request body stringified:", {
        originalBody: i,
        stringifiedBody: f.body,
        bodyContainsStream: JSON.stringify(i).includes('"stream"'),
        streamValue: i?.stream
      })), this.debug("Making request", {
        method: e,
        url: d,
        body: i,
        hasStream: i?.stream,
        stringifiedBody: f.body,
        headers: { ...p, Authorization: "[redacted]" }
      });
      const h = await this.fetch(d, f), u = await h.text();
      let a;
      try {
        a = u ? JSON.parse(u) : null;
      } catch {
        a = { error: { message: u } };
      }
      return h.ok || this.handleErrorResponse(h, a), this.debug("Request successful", { status: h.status, data: a }), a;
    });
  }
  /**
   * Make authenticated HTTP streaming request to SubscribeDev API
   */
  async makeStreamingRequest(e, t, i, n = "chunk", d) {
    const p = `${this._config.baseUrl}${t}`, f = {
      "Content-Type": "application/json",
      "User-Agent": "@subscribe.dev/client/0.1.0",
      Accept: "text/event-stream",
      "Cache-Control": "no-cache"
    };
    if (this._config.accessToken)
      f["x-sub-dev-access-token"] = this._config.accessToken, this.debug("Using universal auth with x-sub-dev-access-token for streaming", {
        tokenPrefix: this._config.accessToken.substring(0, 10) + "..."
      });
    else if (this._config.apiKey) {
      const c = this._config.apiKey.trim().replace(/=+$/, "");
      f.Authorization = `Bearer ${c}`, this.debug("Using project auth with Authorization header for streaming"), this._config.userKey && (f["X-User-Token"] = this._config.userKey, this.debug("Adding X-User-Token for user context in streaming"));
    } else
      this.debug("No authentication tokens available for streaming - unauthenticated request");
    const h = {
      method: e,
      headers: f,
      signal: d || AbortSignal.timeout(this._config.timeout)
    };
    i && ["POST", "PUT", "PATCH"].includes(e) && (h.body = JSON.stringify(i), this.debug("Streaming request body stringified:", {
      originalBody: i,
      stringifiedBody: h.body,
      bodyContainsStream: JSON.stringify(i).includes('"stream"'),
      streamValue: i?.stream
    })), this.debug("Making streaming request", {
      method: e,
      url: p,
      body: i,
      hasStream: i?.stream,
      stringifiedBody: h.body,
      headers: { ...f, Authorization: "[redacted]" }
    }), console.log("[SubscribeDevClient] STREAMING DEBUG - About to fetch streaming request");
    const u = await this.fetch(p, h);
    if (console.log("[SubscribeDevClient] STREAMING DEBUG - Streaming response received:", {
      status: u.status,
      statusText: u.statusText,
      headers: Object.fromEntries(u.headers.entries()),
      contentType: u.headers.get("content-type"),
      hasBody: !!u.body,
      bodyLocked: u.body?.locked,
      ok: u.ok
    }), !u.ok) {
      const c = await u.text();
      let s;
      try {
        s = c ? JSON.parse(c) : null;
      } catch {
        s = { error: { message: c } };
      }
      this.handleErrorResponse(u, s);
    }
    if (!u.body)
      throw console.log("[SubscribeDevClient] STREAMING DEBUG - No response body received"), new Error("No response body received for streaming request");
    console.log("[SubscribeDevClient] STREAMING DEBUG - Creating stream iterable from response body");
    const [a, r] = u.body.tee();
    console.log("[SubscribeDevClient] STREAMING DEBUG - Response body teed for safe reading");
    const m = this.createStreamIterable(a, n);
    return console.log("[SubscribeDevClient] STREAMING DEBUG - Stream iterable created:", {
      type: typeof m,
      hasAsyncIterator: !!(m && typeof m[Symbol.asyncIterator] == "function"),
      constructor: m.constructor.name
    }), m;
  }
  /**
   * Create an async iterable from a ReadableStream for streaming responses
   */
  createStreamIterable(e, t = "chunk") {
    return console.log("[SubscribeDevClient] STREAMING DEBUG - createStreamIterable called with streamBy:", t), {
      [Symbol.asyncIterator]: async function* () {
        const i = e.getReader(), n = new TextDecoder();
        let d = "", p = "";
        try {
          for (; ; ) {
            const { done: f, value: h } = await i.read();
            if (f) {
              if (d) {
                const a = d.split(`
`);
                for (const r of a)
                  if (r && r.startsWith("data: ") && r !== "data: [DONE]")
                    try {
                      const m = r.slice(6), s = JSON.parse(m)?.content || "";
                      s && (p += s);
                    } catch (m) {
                      console.warn("[SubscribeDevClient] Failed to parse remaining chunk:", r, m);
                    }
                p && (yield p);
              }
              break;
            }
            d += n.decode(h, { stream: !0 });
            const u = d.split(`

`);
            d = u.pop() || "";
            for (const a of u)
              if (!(!a || a === "data: [DONE]") && a.startsWith("data: "))
                try {
                  const r = a.slice(6), c = JSON.parse(r)?.content || "";
                  if (c) {
                    if (t === "chunk")
                      p += c, yield p;
                    else if (t === "letter")
                      for (const s of c)
                        p += s, yield p;
                    else if (t === "word") {
                      const s = c.split(/(\s+)/);
                      for (let l = 0; l < s.length; l++) {
                        const o = s[l];
                        o && (p += o, (/[\s\p{P}]/u.test(o) || l === s.length - 1) && (yield p));
                      }
                    }
                  }
                } catch (r) {
                  console.warn("[SubscribeDevClient] Failed to parse streaming chunk:", a, r);
                }
          }
        } catch (f) {
          throw console.error("[SubscribeDevClient] Streaming error:", f), f;
        } finally {
          try {
            i.releaseLock();
          } catch {
          }
        }
      }
    };
  }
  /**
   * Handle error responses and throw appropriate error types
   */
  handleErrorResponse(e, t) {
    const i = e.headers.get("x-request-id") || void 0, n = t?.error || {}, d = n.message || `HTTP ${e.status}`;
    switch (e.status) {
      case 400:
        throw new E(d, n.details, i);
      case 401:
        throw new B(d, i);
      case 402:
        throw n.code === "USER_UNSUBSCRIBED" || d.toLowerCase().includes("unsubscribed") || d.toLowerCase().includes("subscription") ? new J(d, i) : new q(
          d,
          n.details?.remainingCredits,
          n.details?.requiredCredits,
          i
        );
      case 403:
        throw new M(d, i);
      case 404:
        throw new G(d, i);
      case 429:
        throw new $(
          d,
          n.details?.resetTime,
          n.details?.retryAfter,
          i
        );
      default:
        throw new k(
          d,
          n.code || "UNKNOWN_ERROR",
          e.status,
          n.details,
          i
        );
    }
  }
  /**
   * Debug logging
   */
  debug(e, t) {
    this._config.debug && console.log(`[SubscribeDevClient] ${e}`, t || "");
  }
  /**
   * Static method to create client (for convenience)
   */
  static create(e) {
    return new D(e);
  }
}
export {
  M as AccessDeniedError,
  B as AuthenticationError,
  q as InsufficientBalanceError,
  G as NotFoundError,
  $ as RateLimitError,
  O as StreamableResponse,
  D as SubscribeDevClient,
  k as SubscribeDevError,
  J as UnsubscribedError,
  E as ValidationError
};
//# sourceMappingURL=index.js.map
